<template>
  <div>
    <v-row justify="start" align="stretch">
      <v-col cols="12" md="6">
        <v-card height="100%" elevation="2">
          <BasketOverview :loadingBasket="loadingBasket" />
        </v-card>
      </v-col>
      <v-col cols="12" md="6" v-if="showBudget">
        <v-card height="100%" elevation="2">
          <BudgetOverview 
            @budget-hide="showBudget=false"> 
          </BudgetOverview>  
        </v-card>
      </v-col>
      <v-col cols="12" md="12">
        <v-card height="100%" elevation="2">
          <OrdersOverview />
        </v-card>
      </v-col>
      <v-col cols="12" v-if="showOrdersTimeline">
        <v-card height="100%" elevation="2">
          <OrdersTimeline 
            @timeline-hide="showOrdersTimeline=false"> 
          >
          </OrdersTimeline>
        </v-card>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import BasketOverview from "@/components/dashboard/BasketOverview.vue";
import OrdersOverview from "@/components/dashboard/OrdersOverview.vue";
import OrdersTimeline from "@/components/dashboard/OrdersTimeline.vue";
import BudgetOverview from "@/components/dashboard/BudgetOverview.vue";

export default {
  props: {
    loadingBasket: Boolean,
  },
  data() {
    return {
      showBudget : true,
      showOrdersTimeline:true
    }
  },
  components: {
    OrdersOverview,
    BasketOverview,
    OrdersTimeline,
    BudgetOverview
  },
  activated() {
    this.resetData();
  },

  methods: {
    resetData(){
      this.showBudget = true;
      this.showOrdersTimeline = true;
    }
  }
};
</script>

<style lang="sass" scoped>
.v-card
  height: 100%
</style>